import React from "react";
import { MANIFESTO } from "../mock";
import Marquee from "./Marquee";

export default function ManifestoTicker() {
  const items = MANIFESTO.map((t, i) => (
    <React.Fragment key={i}>
      <span className="font-display text-4xl md:text-6xl lg:text-7xl text-ink leading-none">{t}</span>
      <span className="text-amber font-display text-4xl md:text-6xl lg:text-7xl">—</span>
    </React.Fragment>
  ));
  return (
    <section className="bg-bone py-10 border-y border-line">
      <Marquee items={items} speed="marquee" />
    </section>
  );
}
